// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dialog {
  padding: 0;
  border: 0;
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

dialog::backdrop {
  background: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
dialog[open] {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Size-specific styles */
.modal-scrollable {
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
}

.modal-auto-height {
  max-width: 90vw;
  max-height: 90vh;
  overflow: visible;
}

.modal-auto-height > div {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.body-scrollable {
  overflow-y: auto;
  flex: 1;
  padding: 1.5rem;
}

.body-auto {
  padding: 1.5rem;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./packages/ng-shared-ui/src/lib/molecules/modal/modal.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,qBAAA;EACA,qFACE;AAAJ;;AAIA;EACE,8BAAA;EACA,8BAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;AACF;AAIA;EACE,gCAAA;AAFF;;AAKA;EACE;IACE,UAAA;IACA,4BAAA;EAFF;EAIA;IACE,UAAA;IACA,wBAAA;EAFF;AACF;AAKA,yBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,OAAA;EACA,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;AACA,wuEAAwuE","sourcesContent":["dialog {\r\n  padding: 0;\r\n  border: 0;\r\n  border-radius: 0.5rem;\r\n  box-shadow:\r\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\r\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\ndialog::backdrop {\r\n  background: rgba(0, 0, 0, 0.5);\r\n  animation: fadeIn 0.2s ease-in;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\ndialog[open] {\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Size-specific styles */\r\n.modal-scrollable {\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  overflow: auto;\r\n}\r\n\r\n.modal-auto-height {\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  overflow: visible;\r\n}\r\n\r\n.modal-auto-height > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 90vh;\r\n}\r\n\r\n.body-scrollable {\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.body-auto {\r\n  padding: 1.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
